import styled from '@emotion/styled';
import { mediaQuery, responsiveFontSize } from '@presentation/styles';

export const Banner = styled.div`
  position: relative;
  background-color: ${(props) => props.theme.color.blue.light};
  color: ${(props) => props.theme.color.blue.default};
  padding: 40px 20px;
`;

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  ${mediaQuery('tablet')} {
    flex-direction: column;
    gap: 16px;
  }
`;

export const Section = styled.div`
  width: 30%;
  ${mediaQuery('tablet')} {
    width: 100%;
  }
`;

export const Title = styled.div`
  ${responsiveFontSize(24, 1)}
  font-family: ${(props) => props.theme.font.alternate};
  font-weight: 600;
  margin-bottom: 12px;
`;

export const LinksContainer = styled.div``;

export const Link = styled.div`
  margin-bottom: 7px;
  cursor: pointer;

  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;

  ${responsiveFontSize(16, 1)}

  a {
    font-weight: 500;
    color: ${(props) => props.theme.color.blue.default} !important;

    &:hover {
      text-decoration: underline;
      font-weight: 600;
    }
  }

  svg {
    margin-left: 5px;
    font-size: 12px;
  }

  ${mediaQuery('tablet')} {
    justify-content: center;
  }
`;
